



















































import { Component } from "vue-property-decorator";
import QuizPage from "../../components/QuizPage";
import DebugData from "../../components/DebugData.vue";
@Component({
  components: {
    DebugData
  }
})
export default class Ownership extends QuizPage {
  private created() {
    this.init("ownership", "/children");
  }
}
